import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {put, take, race, takeLatest} from 'redux-saga/effects';
import gql from 'graphql-tag';
import {mutation_init, mutation_result} from 'utils/graphql';

import {
  showDealFinalizing,
  hideDealFinalizing,
  showDealFinalized,
  hideDealFinalized,
  showDealClosed,
  hideDealClosed,
} from './reducer';

const namespace = 'flows/deal/status';

// Actions
const DEAL_TRANSITION = defineAction('DEAL_TRANSITION');
export const triggerNextDealTransition = createAction(DEAL_TRANSITION.ACTION);

const DEAL_FINALIZING = defineAction('DEAL_FINALIZING', ['SUBMIT', 'CANCEL'], namespace);
export const cancelFinalizing = createAction(DEAL_FINALIZING.CANCEL);

const DEAL_FINALIZED = defineAction('DEAL_FINALIZED', ['SUBMIT', 'CANCEL'], namespace);
export const cancelFinalized = createAction(DEAL_FINALIZED.CANCEL);

const DEAL_CLOSED = defineAction('DEAL_CLOSED', ['SUBMIT', 'CANCEL'], namespace);
export const cancelClosed = createAction(DEAL_CLOSED.CANCEL);

// Mutations
export const finalizingOp = 'DealTransitionToFinalizing';
export const finalizingMutation = gql`
  mutation ${finalizingOp}($dealId: ID!) {
    deal: transitionToFinalizing(id: $dealId) {
      id
      status
    }
  }
`;
export const finalizingProp = ({mutate, ownProps}) => () => mutate({
  variables: {
    dealId: ownProps.deal.id,
  },
});

export const finalizedOp = 'DealTransitionToFinalized';
export const finalizedMutation = gql`
  mutation ${finalizedOp}($dealId: ID!) {
    deal: transitionToFinalized(id: $dealId) {
      id
      status
    }
  }
`;
export const finalizedProp = ({mutate, ownProps}) => () => mutate({
  variables: {
    dealId: ownProps.deal.id,
  },
});

export const closedOp = 'DealTransitionToClosed';
export const closedQuery = gql`
  query ${closedOp}($dealId: ID!) {
    deal(id: $dealId) {
      id
      allocations {
        id
        self
        documents {
          signed
        }
      }
    }
  }
`;
export const closedMutation = gql`
  mutation ${closedOp}($dealId: ID!) {
    deal: transitionToClosed(id: $dealId) {
      id
      status
    }
  }
`;
export const closedProp = ({mutate, ownProps}) => () => mutate({
  variables: {
    dealId: ownProps.deal.id,
  },
});

// Transition deal to different states saga
export function* dealTransitionSaga({payload}) {
  const {deal} = payload;

  let show;
  let hide;
  let ACTION;
  let op;

  if (deal.status === 'allocating') {
    show = showDealFinalizing;
    hide = hideDealFinalizing;
    ACTION = DEAL_FINALIZING;
    op = finalizingOp;
  } else if (deal.status === 'finalizing') {
    show = showDealFinalized;
    hide = hideDealFinalized;
    ACTION = DEAL_FINALIZED;
    op = finalizedOp;
  } else if (deal.status === 'finalized') {
    show = showDealClosed;
    hide = hideDealClosed;
    ACTION = DEAL_CLOSED;
    op = closedOp;
  } else {
    throw new Error('Deal transition unsupported');
  }

  // show announcement popup
  yield put(show());

  // Wait for user interaction
  const {submit} = yield race({
    submit: take(mutation_init(op)),
    cancel: take(ACTION.CANCEL),
  });

  // Wait for server result
  if (submit) {
    yield take(mutation_result(op));
  }

  // hide announcement modal
  yield put(hide());
}

export function* sagas() {
  yield takeLatest(DEAL_TRANSITION.ACTION, dealTransitionSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/status/index.js